// extracted by mini-css-extract-plugin
module.exports = {"title":"b4d28","text":"_7d883","wrapper":"_4ad9b","spinner":"_23c60","notifications":"a0ace","content":"ed51c","row":"a8ca2","menu":"b027c","message":"_969df"};